import { render, staticRenderFns } from "./estudos.vue?vue&type=template&id=acdd6cea&"
import script from "./estudos.vue?vue&type=script&lang=js&"
export * from "./estudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports